var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.isFail ? _vm.$t("失败明细") : _vm.$t("数据预览"),
      visible: _vm.visible,
      width: 1000
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel"), _vm.close();
      }
    }
  }, [_c("a-spin", {
    attrs: {
      indicator: _vm.indicator,
      spinning: _vm.loading,
      tip: _vm.$t("努力加载中，请稍后")
    }
  }, [_c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.showColumns,
      pagination: _vm.pagination,
      "data-source": _vm.showData,
      size: "small",
      rowClassName: _vm.getClassName,
      rowKey: "id",
      "row-selection": _vm.isFail ? {
        selectedRowKeys: _vm.selectedRowKeys,
        onChange: _vm.onSelectChange
      } : null
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "expandedRowRender",
      fn: function (record) {
        return record.errorMessage && record.errorMessage.length ? _vm._l(record.errorMessage, function (item) {
          return _c("span", {
            key: item,
            staticClass: "err-line"
          }, [_c("span", {
            staticStyle: {
              "font-weight": "700"
            }
          }, [_vm._v("· ")]), _vm._v(" " + _vm._s(_vm.$t(item).replace("不能为空", _vm.$t("不能为空")).replace("格式错误", _vm.$t("格式错误")).replace("与证件号不一致", _vm.$t("与证件号不一致")).replace("与投保人关系为本人的信息与投保人不一致", _vm.$t("与投保人关系为本人的信息与投保人不一致"))) + " ")]);
        }) : undefined;
      }
    }], null, true)
  }, _vm._l(_vm.showColumns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title.replace("*", ""))))]);
  }), 0)], 1), _c("template", {
    slot: "footer"
  }, [_vm.hasError ? _c("a-button", {
    attrs: {
      type: "danger",
      size: "small",
      loading: _vm.loading
    }
  }, [_vm._v(_vm._s(_vm.$t("请修改完错误信息后，重新上传文件")) + " ")]) : _c("a-button", {
    attrs: {
      type: "primary",
      size: "small",
      loading: _vm.loading
    },
    on: {
      click: _vm.updateTemplateAndSave
    }
  }, [_vm._v(_vm._s(_vm.$t("完成")) + " ")])], 1), _c("edit-insure-modal", {
    attrs: {
      templateRenderList: _vm.myTemplateRenderList,
      visible: _vm.editVisible,
      showData: _vm.showData,
      editIndex: _vm.editIndex,
      isFail: _vm.isFail
    },
    on: {
      updateTemplate: _vm.updateTemplate,
      cancel: function ($event) {
        _vm.editVisible = false;
      }
    }
  }), _c("confirm-insure-modal", {
    attrs: {
      visible: _vm.confirmVisible,
      data: _vm.toInsureData,
      again: true
    },
    on: {
      cancel: function ($event) {
        _vm.confirmVisible = false;
      }
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };